import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { simulationCaseCacheKeys } from "./constants";
import type { DeleteSimulationCaseProps } from "./types";

export const deleteSimulationCase = reactQueryMutationAdapter(
  simulationCaseCacheKeys,
  ({ appGroupId, id }: DeleteSimulationCaseProps): Promise<{}> =>
    fetch(`/${appGroupId}/conversational/simulation/cases/${id}`, "DELETE")
);
